<div class="lum-modal bulk-shipping-dialog__modal-wrapper">
  <div class="overlay" lumAppLoader></div>
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">Bulk Shipping Label</span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <div
      *ngIf="invalidWarehouseAddress; else shippingLabelForm"
      class="lum-alert lum-alert--error mb-5"
    >
      Please update <b>"{{ data.warehouseAddress?.name ?? '' }}"</b> from the
      warehouse and use valid address details.
      <p class="mt-2">
        <a href="/locations/warehouses" target="_blank">
          >> Go to Warehouse Settings
        </a>
      </p>
    </div>

    <ng-template #shippingLabelForm>
      <form
        [formGroup]="form"
        class="bulk-shipping__wrapper flex gap-4 grow"
        (submit)="onSubmit()"
      >
        <div class="flex align-center gap-7">
          <div class="block w-100">
            <div class="shipping-quote__label">Ship Date</div>
            <div class="shipping-quote__input">
              <input
                formControlName="shipDate"
                type="date"
                required="true"
                class="lum-input"
              />
              <mat-error *ngIf="shipDateControl && shipDateControl.invalid">
                <small>
                  {{ shipDateControl | validateField }}
                </small>
              </mat-error>
            </div>
          </div>
          <div class="block w-100">
            <div class="shipping-quote__label">Confirmation</div>
            <div class="shipping-quote__input flex align-center gap-2">
              <mat-select formControlName="confirmation" class="lum-select">
                <mat-option
                  *ngFor="let option of confirmationOptions; trackBy: trackByValue"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </div>
        <div class="flex align-center gap-3 justify-content-end mt-5">
          <div></div>
          <lum-sales-order-apply-preset
            *ngIf="data?.appIntegrationAccountId && data?.ftApplyPresets"
            [appIntegrationAccountId]="data?.appIntegrationAccountId || 0"
            (applyPreset)="onApplyPreset($event)"
          ></lum-sales-order-apply-preset>
          <button
            type="button"
            class="lum-button lum-button--primary"
            mat-button
            [disabled]="!hasSelections"
            (click)="onBulkUpdate()"
          >
            <lum-ui-icon
              class="pr-1 pb-1"
              icon="export-pdf"
              color="#ffffff"
            ></lum-ui-icon>
            Bulk Update Shipping Information
          </button>
        </div>
        <div class="flex align-center gap-3">
          <div class="bulk-shipping-dialog__modal-table">
            <div class="scrollable-container">
              <table class="lum-table lum-table--classic striped">
                <thead>
                  <tr class="table__head-row">
                    <th>
                      <mat-checkbox
                        class="lum-checkbox"
                        [checked]="selectedAllItems"
                        [indeterminate]="selectedSomeItems"
                        (change)="onSelectAll($event.checked)"
                      >
                      </mat-checkbox>
                    </th>
                    <th class="text-nowrap" style="width: 70px">Order #</th>
                    <th>Destination</th>
                    <th
                      style="width: 180px"
                      *ngIf="hasMultipleShipmentsForSomeItems"
                      >Shipment</th
                    >
                    <th style="width: 180px">Carrier</th>
                    <th style="width: 240px">Weight</th>
                    <th style="width: 200px">Package</th>
                    <th style="width: 200px">Service</th>
                    <th style="width: 300px">Size</th>
                    <th style="width: 100px">Rate</th>
                  </tr>
                </thead>
                <tbody formArrayName="lineItems">
                  <ng-container
                    *ngFor="
                      let item of lineItemsFormArray.controls;
                      trackBy: trackByControlValue;
                      let idx = index
                    "
                  >
                    <tr [formGroupName]="idx">
                      <td>
                        <mat-checkbox
                          class="lum-checkbox"
                          formControlName="selected"
                        ></mat-checkbox>
                      </td>
                      <td>
                        <div class="text-small">
                          {{ item.value.salesOrderNumber }}
                        </div>
                        <div class="text-x-small">
                          ({{
                            item.value.orderItemsCount +
                              (item.value.orderItemsCount > 1 ? ' items' : ' item')
                          }})
                        </div>
                      </td>
                      <td class="text-x-small">
                        {{ item.value.shipToString ?? '' }}
                      </td>
                      <td *ngIf="hasMultipleShipmentsForSomeItems">
                        <div class="flex align-center gap-3">
                          <div
                            class="w-100"
                            *ngIf="item.value.hasMultipleShipments"
                          >
                            <mat-select
                              formControlName="salesOrderShipmentId"
                              class="lum-select text-small"
                            >
                              <mat-option disabled>--None--</mat-option>
                              <mat-option
                                *ngFor="
                                  let shipment of item.value.salesOrderShipments;
                                  trackBy: trackById
                                "
                                [value]="shipment?.id"
                              >
                                {{ shipment.orderKey }}
                              </mat-option>
                            </mat-select>
                            <mat-error
                              *ngIf="
                                item.get('salesOrderShipmentId') &&
                                item.get('salesOrderShipmentId')?.invalid
                              "
                              >{{
                                item.get('salesOrderShipmentId') | validateField
                              }}</mat-error
                            >
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="flex align-center gap-3">
                          <div class="w-100">
                            <mat-select
                              formControlName="carrierCode"
                              class="lum-select text-small"
                              (selectionChange)="onSelectCarrier($event, idx)"
                            >
                              <mat-option disabled
                                >--
                                {{ loadingCarriers ? 'Loading' : 'None' }}
                                --</mat-option
                              >
                              <mat-option
                                *ngFor="let carrier of carriers"
                                [value]="carrier?.code"
                              >
                                {{ carrier.name }}
                              </mat-option>
                            </mat-select>
                            <mat-error
                              *ngIf="
                                item.get('carrierCode') &&
                                item.get('carrierCode')?.invalid
                              "
                              >{{
                                item.get('carrierCode') | validateField
                              }}</mat-error
                            >
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="flex align-center gap-3" formGroupName="weight">
                          <div class="flex">
                            <div
                              class="flex align-center gap-1 mr-1"
                              formGroupName="pounds"
                            >
                              <div class="flex flex-column">
                                <input
                                  formControlName="value"
                                  type="number"
                                  min="0"
                                  matInput
                                  class="lum-input"
                                />
                                <mat-error
                                  *ngIf="
                                    item.get('weight.pounds.value') &&
                                    item.get('weight.pounds.value')?.invalid
                                  "
                                  >{{
                                    item.get('weight.pounds.value') | validateField
                                  }}</mat-error
                                >
                              </div>
                              <div class="flex justify-content-end">
                                <span
                                  class="
                                    text-underline cursor-pointer text-purple-600 font-semi-bold text-x-small
                                  "
                                >
                                  (LBS)
                                </span>
                              </div>
                            </div>
                            <div
                              class="flex align-center gap-1"
                              formGroupName="ounces"
                            >
                              <div class="flex flex-column">
                                <input
                                  formControlName="value"
                                  type="number"
                                  min="0"
                                  matInput
                                  class="lum-input"
                                />
                                <mat-error
                                  *ngIf="
                                    item.get('weight.ounces.value') &&
                                    item.get('weight.ounces.value')?.invalid
                                  "
                                  >{{
                                    item.get('weight.ounces.value') | validateField
                                  }}</mat-error
                                >
                              </div>
                              <div class="flex justify-content-end">
                                <span
                                  class="
                                    text-underline cursor-pointer text-purple-600 font-semi-bold text-x-small
                                  "
                                >
                                  (OZ)
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>

                      <td>
                        <div class="flex align-center gap-3">
                          <div class="w-100">
                            <mat-select
                              formControlName="packageCode"
                              class="lum-select text-small"
                              *ngIf="
                                !(
                                  loadingPackagesByCarrierCode[
                                    item.value.carrierCode
                                  ] ?? false
                                );
                                else inputLoader
                              "
                            >
                              <mat-option
                                *ngFor="
                                  let package of packagesByCarrierCode[
                                    item.value.carrierCode
                                  ] ?? [];
                                  trackBy: trackByValue
                                "
                                [value]="package?.code"
                              >
                                {{ package.name }}
                              </mat-option>
                            </mat-select>
                          </div>
                        </div>
                      </td>

                      <td>
                        <div class="flex align-center gap-3">
                          <div class="w-100">
                            <mat-select
                              formControlName="serviceCode"
                              class="lum-select text-small"
                              *ngIf="
                                !(
                                  loadingServicesByCarrierCode[
                                    item.value.carrierCode
                                  ] ?? false
                                );
                                else inputLoader
                              "
                            >
                              <mat-option
                                *ngFor="
                                  let service of servicesByCarrierCode[
                                    item.value.carrierCode
                                  ] ?? [];
                                  trackBy: trackByValue
                                "
                                [value]="service?.code"
                              >
                                {{ service.name }}
                              </mat-option>
                            </mat-select>
                          </div>
                        </div>
                      </td>

                      <td>
                        <div class="flex align-center" formGroupName="dimensions">
                          <div class="flex justify-space-between gap-4">
                            <div class="flex align-center gap-1">
                              <input
                                formControlName="length"
                                type="number"
                                min="0"
                                matInput
                                class="lum-input"
                              />
                              <span class="text-small"> L </span>
                            </div>
                            <div class="flex align-center gap-1">
                              <input
                                formControlName="width"
                                type="number"
                                min="0"
                                matInput
                                class="lum-input"
                              />
                              <span class="text-small"> W </span>
                            </div>
                            <div class="flex align-center gap-1">
                              <div class="flex align-center gap-1">
                                <input
                                  formControlName="height"
                                  type="number"
                                  min="0"
                                  matInput
                                  class="lum-input"
                                />
                                <span class="text-small"> H </span>
                              </div>
                              <div class="flex justify-content-end">
                                <span
                                  class="
                                    text-underline cursor-pointer text-purple-600 font-semi-bold text-x-small
                                  "
                                  #menuTrigger="matMenuTrigger"
                                  [matMenuTriggerFor]="dimensionMenu"
                                >
                                  ({{ dimensionsUnitLabels[idx] }})
                                </span>
                                <mat-menu
                                  class="lum-mat-menu"
                                  #dimensionMenu="matMenu"
                                >
                                  <button
                                    *ngFor="
                                      let unit of dimensionUnits;
                                      trackBy: trackByValue
                                    "
                                    mat-menu-item
                                    (click)="
                                      onSetUnit(
                                        fieldNames['dimensions'],
                                        unit.value,
                                        idx
                                      )
                                    "
                                  >
                                    {{ unit.value }} ({{ unit.label }})
                                  </button>
                                </mat-menu>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="flex gap-2">
                          <div class="rates-container flex flex-column">
                            <span class="text-medium font-semi-bold text-green-900"
                              >Rate</span
                            >
                            <span>{{ item.value.shipRate || 0 | currency }}</span>
                          </div>
                          <span class="flip-x">
                            <i
                              class="fa fa-undo text-large cursor-pointer"
                              [ngClass]="{
                                'reverse-spin text-gray-400':
                                  item.value.shipRateLoading,
                              }"
                              (click)="onRefreshRate(item.value)"
                            ></i>
                          </span>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="lum-modal__footer">
          <div class="flex ml-auto lum-modal__action gap-2">
            <button
              class="lum-button lum-button--large"
              [disabled]="form.invalid || submittingForm"
            >
              <span class="d-flex align-items-center">
                Submit
                <mat-spinner
                  class="inline-block ml-1"
                  [diameter]="16"
                  *ngIf="submittingForm || false"
                ></mat-spinner>
              </span>
            </button>
          </div>
        </div>
      </form>
    </ng-template>
  </div>
</div>

<ng-template #inputLoader>
  <div class="lum-input">
    <mat-spinner class="ml-auto" [diameter]="16"></mat-spinner>
  </div>
</ng-template>
